export default "__VITE_ASSET__BJktDBuN__"